const css = `.cc3rLa__box{flex:1;display:flex}.cc3rLa__middle{justify-content:center}.cc3rLa__left{margin-right:auto}.cc3rLa__right{justify-content:flex-end;margin-left:auto}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"middle":"cc3rLa__middle","right":"cc3rLa__right","left":"cc3rLa__left","box":"cc3rLa__box"};
